import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

export default function DeductionCountInput(props) {
  const { disabled, value, setValue, width } = props;
  const { t } = useLanguage();

  function onChangeInput(e) {
    const curValue = e.target.value
    const newValue = curValue.replace(/[^0-9]/g, '')

    if (newValue < 9999999)
      setValue(newValue);
  }

  function onFocusInput() {
  }

  function onBlurInput() {
  }

  return (
    <TopLevelWrapper width={width}>
      <InputWrapper>
        <Input
          placeholder='1'
          value={value || ''}
          disabled={disabled}
          onFocus={onFocusInput}
          onChange={onChangeInput}
          onBlur={onBlurInput} />
      </InputWrapper>
        <Text>회</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: ${props => props.width}px;

  gap: 4px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 27px);
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
`;

const Input = styled.input`
  width: 100%;
  height: 100%;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0px;
  padding: 0px;

  text-align: right;

  border: 0px;
  border-radius: 5px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: ${props => props.theme.line};
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
    border: 1px solid transparent;
    border-radius: 200px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
    border: 4px solid transparent;
    background-color: ${props => props.theme.subBackground};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;
